/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_Faq_Q4Inputs */

const en_guide_large_json_files_faq_q4 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is NDJSON and when should I use it?`)
};

const ko_guide_large_json_files_faq_q4 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDJSON은 무엇이고 언제 써야 하나요?`)
};

const ja_guide_large_json_files_faq_q4 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDJSON とは何で、いつ使うべきですか?`)
};

/**
* | output |
* | --- |
* | "What is NDJSON and when should I use it?" |
*
* @param {Guide_Large_Json_Files_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_faq_q4 = /** @type {((inputs?: Guide_Large_Json_Files_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_faq_q4(inputs)
	if (locale === "ko") return ko_guide_large_json_files_faq_q4(inputs)
	return ja_guide_large_json_files_faq_q4(inputs)
});